
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";

/**
 * Ajax загрузка данных с сервера.
 */
@Injectable()
export class Ajax {
    /**
     * Адрес скрипта куда посылается запрос. Можно его переопределить в мотеде send
     */
    readonly URL = `../epg/ajax.php`;
    /**
     * Количество активных Ajax запросов.
     */
    private count:number = 0;
    /**
     * Елемент HTML который показывается при ajax запросе
     */
    private ajaxLoader:HTMLDivElement;
    /**
     * Флаг выставляется в true когда идет редирект на другую страницу. В FF не срабатывает условие, что route уже делает переход
     * на другую страницу и поэтому выдаёт двойные сообщения.
     */
    private redirectFlag:boolean = false;
    constructor(private http: HttpClient){
    }

    /**
     * Отправка запроса на сервер.
     * @param params Объект, который будет передан в URL Запроса.
     * @param showAjax Показывать ли иконку загрузки
     * @param url Адрес скрипта куда посылается запрос
     * @returns {Observable<any>}
     */
    send(params:PostData, showAjax:boolean = true, url:string = ""):Observable<any>{
        if(showAjax){
            if(!this.ajaxLoader) this.ajaxLoader = <HTMLDivElement>document.getElementById("ajaxActivity");
            if(this.count <= 0) this.ajaxLoader.className = "show";
            this.count++;
        }
        const data = new URLSearchParams();
        for(let key in params){
            data.set(key,params[key].toString());
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        return this.http.post<PostResponse>(url || this.URL, data.toString(), {headers, responseType: "json"})
            .pipe(
                    map((response:PostResponse) => {
                        if(showAjax){
                            this.count--;
                            if(this.count<=0) this.ajaxLoader.className = "";
                        }
                        if(response.op == true) {
                            return response.data;
                        }
                        else if(typeof response.message == "string" && showAjax) {
                            alert(response.message);
                            throw  ("NO Message");
                        } else if(showAjax) {
                            alert("Операция прошла с ошибкой!");
                            throw ("NO Message");
                        }
                    }),
                    catchError((error:string):Observable<string>=>{
                        if ( error  == "NO Message"){}
                        else{
                            if(showAjax){
                                this.count--;
                                if(this.count<=0) this.ajaxLoader.className = "";
                                alert("При загрузке данных, произошла ошибка");
                            }
                        }
                        return observableThrowError(error);
                    })
            );
    }
}

/**
 * Объект передаваемы в Post запросе
 */
 export interface PostData {
    /**
     * Имя проводимой операции.
     */
    op:string;
    [propName: string]:string|number;
}

export interface PostResponse {
    // Результат операции
    op:boolean;
    // Массив данных возвращаемых сервером
    data:any;
    // Сообщение об ошибке
    message:string;
    // Адрес для редиректа страницы
    redirectUrl?:string;
}
